import React, { useState } from "react";
import { Card, Button, Collapse, Spinner } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import HotTopics from "../card/hotTopic";
import Suggestions from "../card/suggestion";
import Unanswered from "../card/unanswered";
import axios from "axios";
import { API_URL_PAYMENT } from "../../../utilities/url";
import { RiAiGenerate } from "react-icons/ri";
import { Slide, toast, ToastContainer } from "react-toastify";
import moment from "moment";
import authService from "../../../services/auth.service";

const ReportSentimentAnalysis = ({
  dataHotTopic,
  setDataHotTopic,
  dataSuggestion,
  setDataSuggestion,
  dataUnanswered,
  setDataUnanswered,
  idChatbot,
  usr,
  workspace,
  open1,
  setOpen1,
  open2,
  setOpen2,
  open3,
  setOpen3,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);

  const generateHotTopic = () => {
    setIsLoading(true);
    axios
      .get(API_URL_PAYMENT + "dashboard/osa/aiextraction", {
        params: {
          osaid: idChatbot,
          lastndays: 30,
          lang: "Indonesian",
          ndata: 5,
          summarytype: "hot-topic",
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setIsLoading(false);
          setDataHotTopic(
            response.data.data.length > 0
              ? response.data.data.map((item) => ({
                  ...item,
                  ts_created: new Date().toISOString(),
                }))
              : []
          );
          toast.success("Success to generate !", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        } else {
          setIsLoading(false);
          toast.error("Failed to generate !", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const generateSuggestion = () => {
    setIsLoading2(true);
    axios
      .get(API_URL_PAYMENT + "dashboard/osa/aiextraction", {
        params: {
          osaid: idChatbot,
          lastndays: 30,
          lang: "Indonesian",
          ndata: 5,
          summarytype: "content-suggestion",
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setIsLoading2(false);
          setDataSuggestion(
            response.data.data.length > 0
              ? response.data.data.map((item) => ({
                  ...item,
                  ts_created: new Date().toISOString(),
                }))
              : []
          );
          toast.success("Success to generate !", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        } else {
          setIsLoading2(false);
          toast.error("Failed to generate !", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const generateUnanswered = () => {
    setIsLoading3(true);
    axios
      .get(API_URL_PAYMENT + "dashboard/osa/aiextraction", {
        params: {
          osaid: idChatbot,
          lastndays: 30,
          lang: "Indonesian",
          ndata: 5,
          summarytype: "unanswered",
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setIsLoading3(false);
          setDataUnanswered(
            response.data.data.length > 0
              ? response.data.data.map((item) => ({
                  ...item,
                  ts_created: new Date().toISOString(),
                }))
              : []
          );
          toast.success("Success to generate !", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        } else {
          setIsLoading3(false);
          toast.error("Failed to generate !", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
          });
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <div>
      <ToastContainer />
      {/* Card 1 */}
      <Card className="mb-3">
        <Card.Header
          onClick={() => setOpen1(!open1)}
          className="d-flex cursor-pointer justify-content-between align-items-center bg-success"
        >
          <span className="text-light fw-bold fs-14">Hot Topic</span>
          <Button
            variant="none"
            className="btn-sm text-light"
            aria-controls="collapse-text-1"
            aria-expanded={open1}
          >
            {open1 ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
          </Button>
        </Card.Header>
        <Collapse in={open1}>
          <div id="collapse-text-1">
            <Card.Body className="border border-1 rounded text-dark">
              <div className="row">
                <div className="d-flex justify-content-between mb-3">
                  <div className="text-dark fw-bold">
                    {dataHotTopic.length > 0
                      ? moment(dataHotTopic[0].ts_created)
                          .startOf("day")
                          .isSame(moment().startOf("day"), "day")
                        ? "Last Update: Today"
                        : "Last Update: " +
                          moment(dataHotTopic[0].ts_created).format(
                            "DD MMMM YYYY"
                          )
                      : null}
                  </div>
                  <button
                    onClick={() => generateHotTopic()}
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {!isLoading ? (
                      <>
                        <RiAiGenerate
                          className="me-2"
                          size={18}
                          style={{ marginTop: "-2px" }}
                        />
                        Generate
                      </>
                    ) : (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Generate
                      </>
                    )}
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <HotTopics dataHotTopic={dataHotTopic} />
                </div>
              </div>
            </Card.Body>
          </div>
        </Collapse>
      </Card>

      {/* Card 2 */}
      <Card className="mb-3">
        <Card.Header
          onClick={() => setOpen2(!open2)}
          className="d-flex cursor-pointer justify-content-between align-items-center bg-primary"
        >
          <span className="text-light fw-bold fs-14">Content Suggestions</span>
          <Button
            variant="none"
            className="btn-sm text-light"
            aria-controls="collapse-text-2"
            aria-expanded={open2}
          >
            {open2 ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
          </Button>
        </Card.Header>
        <Collapse in={open2}>
          <div id="collapse-text-2">
            <Card.Body className="border border-1 rounded text-dark">
              <Card.Text>
                <div className="row">
                  <div className="d-flex justify-content-between mb-3">
                    <div className="fw-bold">
                      {dataSuggestion.length > 0
                        ? moment(dataSuggestion[0].ts_created)
                            .startOf("day")
                            .isSame(moment().startOf("day"), "day")
                          ? "Last Update: Today"
                          : "Last Update: " +
                            moment(dataSuggestion[0].ts_created).format(
                              "DD MMMM YYYY"
                            )
                        : null}
                    </div>
                    <button
                      onClick={() => generateSuggestion()}
                      className="btn btn-primary"
                      disabled={isLoading2}
                    >
                      {!isLoading2 ? (
                        <>
                          <RiAiGenerate
                            className="me-2"
                            size={18}
                            style={{ marginTop: "-2px" }}
                          />
                          Generate
                        </>
                      ) : (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Generate
                        </>
                      )}
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Suggestions dataSuggestion={dataSuggestion} />
                  </div>
                </div>
              </Card.Text>
            </Card.Body>
          </div>
        </Collapse>
      </Card>

      {/* Card 3 */}
      <Card className="mb-2">
        <Card.Header
          onClick={() => setOpen3(!open3)}
          className="d-flex cursor-pointer justify-content-between align-items-center bg-warning"
        >
          <span className="text-light fw-bold fs-14">Unanswered</span>
          <Button
            variant="none"
            className="btn-sm text-light"
            aria-controls="collapse-text-3"
            aria-expanded={open3}
          >
            {open3 ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
          </Button>
        </Card.Header>
        <Collapse in={open3}>
          <div id="collapse-text-3">
            <Card.Body className="border border-1 rounded text-dark">
              <Card.Text>
                <div className="row">
                  <div className="d-flex justify-content-between mb-3">
                    <div className="text-dark fw-bold">
                      {dataUnanswered.length > 0
                        ? moment(dataUnanswered[0].ts_created)
                            .startOf("day")
                            .isSame(moment().startOf("day"), "day")
                          ? "Last Update: Today"
                          : "Last Update: " +
                            moment(dataUnanswered[0].ts_created).format(
                              "DD MMMM YYYY"
                            )
                        : null}
                    </div>
                    <button
                      onClick={() => generateUnanswered()}
                      className="btn btn-primary"
                      disabled={isLoading3}
                    >
                      {!isLoading3 ? (
                        <>
                          <RiAiGenerate
                            className="me-2"
                            size={18}
                            style={{ marginTop: "-2px" }}
                          />
                          Generate
                        </>
                      ) : (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Generate
                        </>
                      )}
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Unanswered dataUnanswered={dataUnanswered} />
                  </div>
                </div>
              </Card.Text>
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </div>
  );
};

export default ReportSentimentAnalysis;
